"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Badge;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactSvg = require("react-svg");

require("./badge.scss");

function Badge(props) {
  var title = props.children,
      variant = props.variant,
      iconSrc = props.iconSrc,
      svgClassName = props.svgClassName,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      rest = (0, _objectWithoutProperties2["default"])(props, ["children", "variant", "iconSrc", "svgClassName", "className"]);
  var coloring = pickColoringForVariant(variant);
  return /*#__PURE__*/_react["default"].createElement("span", Object.assign({
    className: "nstyle__badge ".concat(coloring, " ").concat(className)
  }, rest), iconSrc && /*#__PURE__*/_react["default"].createElement(_reactSvg.ReactSVG, {
    src: iconSrc,
    svgClassName: svgClassName
  }), title);
}

function pickColoringForVariant(variant) {
  switch (variant === null || variant === void 0 ? void 0 : variant.toLowerCase()) {
    case "grey":
      return "blue-grey-on-grey";

    case "transparent blue":
      return "blue-on-transparent";

    default:
      return "white-on-blue";
  }
}